<template>
  <v-card tile class="my-2 card-shadow" @click="read(postIdx)">
    <div class="mb-3 text-xs-left">
      <v-layout align-center>
        <v-img :src="thumbnailSrc" :aspect-ratio="16/9" class="grey lighten-5">
          <v-layout justify-center align-center fill-height v-if="type === 'video'">
            <img src="@/assets/img/play-video.png" style="width: 48px; height: 48px;">
          </v-layout>
          <v-icon color="white"
                  size="24px"
                  class="my-0 ml-0"
                  @click.stop="bookmark"
                  style="position: absolute; top: 8px; right: 8px;"
                  v-text="bookmarks ? '$vuetify.icons.bookmarkFilled' : '$vuetify.icons.bookmarkTwoTone'">
          </v-icon>
        </v-img>
      </v-layout>
    </div>

    <v-layout row class="px-3">
      <v-flex>
        <v-card-title class="pa-0 mb-2 post-title align-start">
          <span v-if="title">{{ title }}</span>
          <span v-else>제목 없는 글</span>
        </v-card-title>
      </v-flex>
    </v-layout>

    <v-card-actions class="px-3 pt-2 pb-3">
      <v-list-tile class="grow post-actions">
        <v-list-tile-avatar size="24px" class="mr-2" style="min-width: 0;">
          <v-img size="24px" :src="profileImageSrc" lazy-src="@/assets/img/profile-default.png"></v-img>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <span class="user-name" v-text="channel.title"></span>
          <span class="caption">{{ published }}</span>
        </v-list-tile-content>

        <v-layout align-center justify-end>
<!--          <v-layout row align-center style="flex-shrink: 0; flex-grow: 0;">-->
<!--            <v-icon color="#a9a9af" size="16px">$vuetify.icons.visible</v-icon>-->
<!--            <span class="counter" v-text="viewCnt"></span>-->
<!--          </v-layout>-->

          <v-layout row align-center class="ml-3" style="flex-shrink: 0; flex-grow: 0;">
            <v-icon :color="likes ? '#ec2f54' : '#a9a9af'" size="16px" @click.stop="like">$vuetify.icons.heartFilled</v-icon>
            <span class="counter" v-text="likeCnt"></span>
          </v-layout>

          <v-layout row align-center class="ml-3" style="flex-shrink: 0; flex-grow: 0;">
            <v-icon color="#a9a9af" size="16px">$vuetify.icons.commentFilled</v-icon>
            <span class="counter" v-text="commentCnt"></span>
          </v-layout>
        </v-layout>

      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { timeToDotString } from '@/util/util'

  export default {
    name: 'VlogListCard',
    props: {
      type: {
        type: String,
        required: true,
      },
      videoId: {
        type: String,
        required: true,
      },
      postIdx: {
        type: Number,
        required: true,
      },
      createdAt: {
        type: Number,
        required: true,
      },
      updatedAt: {
        type: Number,
        required: true,
      },
      menuIdx: {
        type: Number,
        // required: true
      },
      menuName: {
        type: String,
      },
      nationIdx: {
        type: Number,
        // required: true
      },
      nationName: {
        type: String,
      },
      title: {
        type: String,
      },
      contents: {
        type: String,
      },
      thumbnail: {
        type: String,
      },
      imageList: {
        type: Array,
      },
      bookmarks: {
        type: Boolean,
      },
      channel: {
        type: Object,
      },
      viewCnt: {
        type: Number,
      },
      likeCnt: {
        type: Number,
      },
      likes: {
        type: Boolean,
      },
      commentCnt: {
        type: Number,
      }
    },
    computed: {
      profileImageSrc () {
        return this.channel.thumbnail ? `${this.$storage}/channel/${this.channel.thumbnail}` : require('@/assets/img/profile-default.png');
      },
      published () {
        return timeToDotString(this.createdAt, this.createdAt, this.now);
      },
      thumbnailSrc () {
        return `https://i.ytimg.com/vi/${this.videoId}/hqdefault.jpg`;
      }
    },
    methods: {
      read (idx) {
        this.$router.push({ name: 'ReadVideo', params: { idx }});
      },
      like () {
        if (this.userIdx === 0) this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        else this.$emit('like');
      },
      bookmark () {
        if (this.userIdx === 0) this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        else this.$emit('bookmark');
      },
    }
  }
</script>

<style lang="scss" scoped>
  .card-shadow {
    /*padding: 16px;*/
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  .custom-chip {
    &-small {
      height: 24px;
      border: 1px solid #eaeaea;
      font-size: 10px;
      line-height: 10px;
      letter-spacing: -0.36px;
      color: #4a4a4a !important;
      background-color: white !important;
      margin: 0;
    }
    &-background {
      background-color: #f4f4f4 !important;
    }
  }
  .custom-chip-small + .custom-chip-small {
    margin-left: 8px;
  }
  /deep/.custom-chip-small .v-chip__content {
    padding-left: 8px;
    padding-right: 8px;
  }

  .post-title {
    text-align: left;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: -0.34px;
    font-weight: 700;
    color: #4a4a4a;

    word-break: keep-all;
    word-wrap: break-word;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .post-contents {
    margin-bottom: 32px;
    text-align: left;
    font-size: 12px;
    line-height: 17px;
    letter-spacing: -0.26px;
    color: #9b9b9b;

    word-break: keep-all;
    word-wrap: break-word;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .post-image-holder {
    flex: 0 0 auto;
    border-radius: 5px;
  }

  /deep/.post-actions {
    .v-list__tile {
      padding: 0;
      height: auto;
    }
  }

  .user-name {
    color: #4a4a4a;
    font-size: 10px;
    line-height: 12px;
  }

  .caption {
    color: #9b9b9b;
    font-size: 10px !important;
    line-height: 12px;
  }

  .counter {
    color: #969596;
    margin-left: 8px;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: -0.26px;
  }
</style>
